import { render } from "./PayeeInformation.vue?vue&type=template&id=cb9d1724&scoped=true&ts=true"
import script from "./PayeeInformation.vue?vue&type=script&lang=ts"
export * from "./PayeeInformation.vue?vue&type=script&lang=ts"

import "./PayeeInformation.vue?vue&type=style&index=0&id=cb9d1724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9d1724"]])

export default __exports__